"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPluginOptions = void 0;

var deepmerge_1 = __importDefault(require("deepmerge"));
/**
 *
 *
 * @export
 * @param {object} defaults
 * @param {object} themeOptions
 * @returns
 */


function getPluginOptions(defaults, themeOptions) {
  return function (optionKey) {
    var defaultOptions = defaults[optionKey] || {};
    var options = themeOptions[optionKey] || {};
    return deepmerge_1.default(defaultOptions, options);
  };
}

exports.getPluginOptions = getPluginOptions;